/* unplugin-vue-components disabled */import script from "./Message.vue?vue&type=script&setup=true&lang=js"
export * from "./Message.vue?vue&type=script&setup=true&lang=js"

import "./Message.vue?vue&type=style&index=0&id=3b51e5f6&lang=scss"

const __exports__ = script;

export default __exports__